import { Component, OnInit, OnDestroy } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';

@Component({
  selector: 'app-askforfertilizer',
  templateUrl: './askforfertilizer.component.html',
  styleUrls: ['./askforfertilizer.component.css']
})
export class AskforfertilizerComponent implements OnInit, OnDestroy {

  zone:any;
  usercode:any;
  constructor(private spinner:NgxSpinnerService,private auth:Authenticationservice) { 
    let userdata:any;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.usercode = userdata.supcode;
    this.goloadfarmerinzone();
    this.goloadstock();
    this.goloadfertilizercode();
  }



  ngOnInit(): void {
  }

  // โหลดข้อมูล stock ปุ๋ย
  fertilizerstock:any;
  goloadstock(){
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_StockBRD")
    .then(res => {
      this.fertilizerstock = res.data.recordset;
    }).catch(err=> { throw(err) })
  } 
  // โหลดข้อมูลชาวไร่ในเขต
  famerlist:any;
  goloadfarmerinzone(){
    this.spinner.show();
    let url ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6566?supzone="+this.zone;
    axios.get(url)
    .then(res => {
      this.famerlist = res.data.recordset;
    }).catch(err => {console.log(err);})
    this.spinner.hide();
  }

  // โหลดข้อมูลชาวไร่ 1 คน
  dataonefarmer:any;
  goloaddata(){
    this.spinner.show();
    let fmcode = ((<HTMLInputElement>document.getElementById("codefm")).value).slice(1,11)
    let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_cp6566_basic_aw?fmcode='"+ fmcode +"'";
    axios.get(url)
    .then(res => {
    console.log(res.data.recordset);

      this.dataonefarmer = res.data.recordset;
    }).catch(err => {console.log(err);})
    this.spinner.hide();
  }

  fertilizercode:any;
  goloadfertilizercode(){
    this.spinner.show();
    let url ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_stock_w?group_type=1";
    axios.get(url)
    .then(res => {
      this.fertilizercode = res.data.recordset;
    }).catch(err => {console.log(err);})
    this.spinner.hide();
  }

  onedata:any;
  fname:any;
  plantno:any = "กรุณาเลือกแปลง";
  gocheckonedata(itid){
    this.onedata = this.dataonefarmer.filter(el => el.itid == itid);
    this.fname = this.onedata[0].fmname;
    this.plantno = this.onedata[0].intlandno;
  }


  Savedataashfertilizer(){
    let url="";
    axios.post(url)
    .then(res => {
      if (res.data.rowsAffected[0] == 1)
      {alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ ^^");}
      else if (res.data.rowsAffected[0] == 0 || res.data.code)
      {alert("!!!! บันทึกข้อมูลไม่สำเร็จ !!!!");}
      })
      .catch(err => { throw(err)})
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.famerlist = null;
    this.onedata = null;
    this.fertilizercode = null;
    this.dataonefarmer = null;
    this.fertilizerstock = null;
  }
}
